module.exports = __webpack_public_path__ + "img/avatar1.6d7de734.png";